import * as Tooltip from '@radix-ui/react-tooltip';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Z_INDEX } from '@hero/constants';

const AppNavigation = styled.div`
  align-items: center;
  background-color: var(--color-bg-weakest2);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  justify-content: space-between;
  min-height: 39px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 8px;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari Opera */
  }

  @media (min-width: 640px) {
    padding: 4px 24px;
  }
`;

const AppNavigationItems = styled.div`
  display: flex;
  gap: 4px;
  position: relative;
`;

const NavLink = styled(Link)`
  align-items: center;
  background-color: transparent;
  border-radius: var(--size-border-radius-sm);
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;
  transition: background-color 150ms ease;
  z-index: ${Z_INDEX.standart1};

  &:before,
  &:after {
    background-color: transparent !important;
  }

  ${({ isActive }) =>
    isActive
      ? css`
          background-color: var(--color-bg-body);
          border: 1px solid var(--color-border-default);
          z-index: ${Z_INDEX.standart2};
        `
      : css`
          &:hover {
            background-color: var(--color-bg-weakest);
          }
        `}
`;

const NavExternalLink = styled(NavLink.withComponent('a'))``;

const TooltipContent = styled(Tooltip.Content)`
  background-color: var(--color-bg-strongest);
  border-radius: var(--size-border-radius-sm);
  color: var(--color-fg-inverse-default);
  padding: 4px 8px;
  pointer-events: none;
  text-align: center;
  width: 160px;
  z-index: ${Z_INDEX.appNavigationTooltip};
`;

const TooltipArrow = styled(Tooltip.Arrow)`
  fill: var(--color-bg-strongest);
`;

export {
  AppNavigation,
  AppNavigationItems,
  NavExternalLink,
  NavLink,
  TooltipArrow,
  TooltipContent
};
